import { Button, Modal, ModalBody, ModalCloseButton, ModalContent, ModalFooter, ModalHeader, ModalOverlay, useDisclosure, useToast } from "@chakra-ui/react";
import axios from "axios";
import { useNavigate } from "react-router-dom";

const AdminCancleOrder=({name})=>{
    const { isOpen, onOpen, onClose } = useDisclosure();
    const toast = useToast();
    const navi=useNavigate();
    const CancleOrder=(id)=>{
        axios.delete(`https://fine-ruby-rattlesnake-suit.cyclic.app/order/delete/${id}`,{
            headers:{"Authorization":"eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJlbWFpbCI6ImFtYXJAZ21haWwuY29tIiwiVXNlcklkIjoiNjNjZDUwYzdlZGNkMDM5ZjA2YmYwYTE0IiwiaWF0IjoxNjc0NDA3MTQ5fQ.qj6hJr1rBM7SkvAdWfaiwuNhqawJTP3SejcdvqN6qOo"}
        }).then(res=>console.log(res.data)).catch(err=>console.log(err));
    }
    return <>
        <Button onClick={onOpen} bg="red.400" color="white">CANCLE ORDER</Button>
        <Modal isOpen={isOpen} onClose={onClose}>
          <ModalOverlay />
          <ModalContent>
            <ModalHeader>DELETE USER</ModalHeader>
            <ModalCloseButton />
            <ModalBody>
                <h1>Are you sure want to delete {name.name}</h1>
            </ModalBody>
            <ModalFooter>
              <Button
                bg="blue.400" color="white" mr="17px"
                onClick={() =>{
                    // toast({
                    //   title: `Account ${name}.`,
                    //   description: "We've created your account for you.",
                    //   status: 'success',
                    //   duration: 9000,
                    //   isClosable: true,
                    // });
                    toast({
                      title: `Account Deleted ${name.name}.`,
                      status: 'success',
                      duration: 2000,
                      isClosable: true,
                    });
                    CancleOrder(name._id);
                    onClose();
                  }
                }
              >
                YES
              </Button>
              <Button colorScheme='blue' mr={3} onClick={onClose} bg="red.400" color="white">
                No
              </Button>
            </ModalFooter>
          </ModalContent>
        </Modal>
    </>
}

export default AdminCancleOrder;